module.exports = __webpack_public_path__ + "img/murloc_camp_small.b78b50bb.png";